import { useEffect, useRef } from "react"
import { AnimatePresence, useInView } from "framer-motion"
import styled from "styled-components"

import Marker from "./Marker"
import Caption from "./Caption"
import Line from "./Line"

const PoiContainer = styled.div`
  position: absolute;
  left: ${(props) => props.left}vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledMarker = styled(Marker)`
  position: absolute;
  top: 42vh;
  height: 60px;
`

const StyledCaption = styled(Caption)`
  position: absolute;
  top: 15vh;
  z-index: 1;
`

const Poi = ({
  name,
  position,
  videoUri,
  windowWidth,
  setVideoDetails,
  isCaptionVisible,
  isPlayingVideo,
}) => {
  const poiRef = useRef(null)
  const margin = (windowWidth / 2 - windowWidth * 0.2) * -1
  const isInView = useInView(poiRef, { margin: `0px ${margin}px` })

  useEffect(() => {
    if (isInView && !isPlayingVideo) {
      setVideoDetails((state) => ({
        ...state,
        videoUri: videoUri,
      }))
    }
  }, [isInView, isPlayingVideo, setVideoDetails, videoUri])

  const onClickHandler = () => {
    setVideoDetails({
      videoUri: videoUri,
      shallPlayVideo: true,
      title: name,
    })
  }

  return (
    <PoiContainer ref={poiRef} left={position}>
      <AnimatePresence>
        {isInView && isCaptionVisible && (
          <>
            <StyledCaption key={"Caption"} onClick={onClickHandler} title={name} />
            <Line key={"Line"} />
          </>
        )}
      </AnimatePresence>
      <StyledMarker
        onClick={isInView ? onClickHandler : null}
        isVisible={true}
        isPulsing={isInView}
        pulseDelay={0.0}
        boxSize={64}
        markerSize={24}
        strokeWidth={3}
      />
    </PoiContainer>
  )
}

export default Poi
